import { fetchAuthSession } from 'aws-amplify/auth';
import { get } from 'aws-amplify/api';
import { useQuery } from 'react-query';

export const SYMPTOMS_QUERY_KEY = 'hrSymptomsData';
export const CATALOG_SYMPTOM_QUERY_KEY = 'hrCatalogSymptomData';

export const useSymptomsQuery = (patientUserId) => {
  return useQuery({
    queryKey: [SYMPTOMS_QUERY_KEY, patientUserId],
    queryFn: listSymptoms.bind(this, patientUserId, null),
    placeholderData: [],
    enabled: !!patientUserId,
  });
};
export const useSymptomsByDateQuery = (patinetUserId, date) => {
  return useQuery({
    queryKey: [SYMPTOMS_QUERY_KEY, patinetUserId, date],
    queryFn: listSymptoms.bind(this, patinetUserId, null),
    placeholderData: [],
    enabled: !!patinetUserId,
    fetchPolicy: 'network-only',
    select: (symptoms) =>
      symptoms.filter(
        (s) => s.symptomStartDate === date || s.symptomEndDate === date
      ),
  });
};
export const useSymptomQuery = (patientUserId, symptomId) => {
  let queryKey = [SYMPTOMS_QUERY_KEY, patientUserId];
  return useQuery({
    queryKey: queryKey,
    queryFn: listSymptoms.bind(this, patientUserId, symptomId),
    enabled: !!symptomId && !!patientUserId,
    fetchPolicy: 'network-only',
    select: (symptoms) => {
      const symptom = symptoms.find((s) => s.id === symptomId);
      if (symptom) {
        return {
          ...symptom,
          symptomStartDate: symptom.symptomStartDate?.replace(/-/g, '/') ?? '',
          symptomEndDate: symptom.symptomEndDate?.replace(/-/g, '/') ?? '',
        };
      }
      return null; 
    }
  });
};

const listSymptoms = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: 'hrsymptomsapi',
    path: `/symptoms/${patientUserId}`,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return (await body?.json()) || [];
};

export const useCatalogSymptomsQuery = () => {
  return useQuery({
    queryKey: [CATALOG_SYMPTOM_QUERY_KEY],
    queryFn: async () => {
      const session = await fetchAuthSession();
      const { body } = await get({
        apiName: 'hrsymptomsapi',
        path: `/catalog-symptoms`,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
        },
      }).response;
      return (await body?.json()) || [];
    },
    staleTime: Infinity,
    placeholderData: [],
  });
};
